export default __webpack_public_path__ + "static/media/cc-task-schedule.d2c5e691.jpg";